const selectors = {
  mediaInfo: (state) => state.mediaDetails.mediaInfo,

  loadingMediaStatus: (state) => state.mediaDetails.loadingMediaStatus,
  mediaDeletingStatus: (state) => state.mediaDetails.mediaDeletingStatus,
  mediaEditingStatus: (state) => state.mediaDetails.mediaEditingStatus,
};

export { selectors };
